/**
 * Дрил-даун-навигация в боковом меню разделов (section_content.html).
 *
 * Верхний уровень -> список подпунктов выбранной группы, поиск по всем пунктам,
 * независимый скролл и автооткрытие активной группы. Контент грузит
 * dashboardContentLoader.js — здесь только переключаются панели меню.
 */
document.addEventListener('DOMContentLoaded', function () {
  const rootList = document.getElementById('menu-root');
  const childrenPanel = document.getElementById('menu-children');
  const searchInput = document.getElementById('menu-search');
  const searchResults = document.getElementById('menu-search-results');
  if (!rootList || !childrenPanel || !searchInput || !searchResults) return;

  const backBtn = document.getElementById('menu-back');
  const groupLabel = document.getElementById('menu-group-label');
  const contentArea = document.getElementById('content-area');
  const firstPageId = contentArea ? contentArea.dataset.firstPageId : '';

  const groupButtons = rootList.querySelectorAll('.menu-group-btn');
  const groupPanels = childrenPanel.querySelectorAll('[data-group-panel]');
  const pageLinks = function () {
    return document.querySelectorAll('.nav-link[data-page-id]');
  };

  const groupNames = {};
  groupButtons.forEach(function (btn) {
    const labelEl = btn.querySelector('.menu-group-label-text');
    groupNames[btn.dataset.groupId] = labelEl ? labelEl.textContent.trim() : btn.textContent.trim();
  });

  let mode = 'root';

  function findRealLink(pageId) {
    let found = null;
    pageLinks().forEach(function (link) {
      if (!found && link.dataset.pageId === pageId) found = link;
    });
    return found;
  }

  function setActiveGroup(groupId) {
    groupButtons.forEach(function (btn) {
      btn.classList.toggle('active', !!groupId && btn.dataset.groupId === groupId);
    });
  }

  function markActive(pageId) {
    let groupId = null;
    pageLinks().forEach(function (link) {
      const isActive = link.dataset.pageId === pageId;
      link.classList.toggle('active', isActive);
      if (isActive && link.dataset.group) groupId = link.dataset.group;
    });
    setActiveGroup(groupId);
    return groupId;
  }

  function scrollActiveIntoView(pageId) {
    const link = findRealLink(pageId);
    if (link && link.scrollIntoView) link.scrollIntoView({ block: 'nearest' });
  }

  function showRoot() {
    mode = 'root';
    searchResults.classList.add('d-none');
    childrenPanel.classList.add('d-none');
    rootList.classList.remove('d-none');
  }

  function showGroup(groupId) {
    mode = 'group';
    searchResults.classList.add('d-none');
    rootList.classList.add('d-none');
    childrenPanel.classList.remove('d-none');
    groupPanels.forEach(function (panel) {
      panel.classList.toggle('d-none', panel.dataset.groupPanel !== groupId);
    });
    if (groupLabel) groupLabel.textContent = groupNames[groupId] || '';
  }

  function clearSearch() {
    searchInput.value = '';
    searchResults.classList.add('d-none');
    searchResults.innerHTML = '';
  }

  function buildSearchResults(query) {
    const q = query.trim().toLowerCase();
    searchResults.innerHTML = '';
    if (!q) return;

    const items = [];
    pageLinks().forEach(function (link) {
      const label = link.textContent.trim();
      const id = link.dataset.pageId || '';
      if (label.toLowerCase().indexOf(q) === -1 && id.toLowerCase().indexOf(q) === -1) return;
      items.push({ id: id, label: label, group: link.dataset.group || '' });
    });

    if (!items.length) {
      const empty = document.createElement('li');
      empty.className = 'nav-item px-3 py-2 small text-muted';
      empty.textContent = 'Ничего не найдено';
      searchResults.appendChild(empty);
      return;
    }

    items.forEach(function (item) {
      const li = document.createElement('li');
      li.className = 'nav-item';
      const a = document.createElement('a');
      a.href = '#';
      a.className = 'nav-link menu-search-result';
      a.dataset.searchPageId = item.id;
      a.title = item.label;

      const title = document.createElement('span');
      title.className = 'd-block';
      title.textContent = item.label;
      a.appendChild(title);

      if (item.group) {
        const sub = document.createElement('span');
        sub.className = 'd-block small text-muted';
        sub.textContent = groupNames[item.group] || item.group;
        a.appendChild(sub);
      }

      a.addEventListener('click', function (e) {
        e.preventDefault();
        const real = findRealLink(item.id);
        if (!real) return;
        real.click();
        clearSearch();
        if (item.group) {
          showGroup(item.group);
          scrollActiveIntoView(item.id);
        } else {
          showRoot();
        }
      });

      li.appendChild(a);
      searchResults.appendChild(li);
    });
  }

  groupButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      clearSearch();
      showGroup(btn.dataset.groupId);
    });
  });

  if (backBtn) {
    backBtn.addEventListener('click', function (e) {
      e.preventDefault();
      clearSearch();
      showRoot();
    });
  }

  pageLinks().forEach(function (link) {
    link.addEventListener('click', function () {
      if (link.dataset.pageId) setActiveGroup(link.dataset.group || null);
    });
  });

  searchInput.addEventListener('input', function () {
    if (searchInput.value.trim()) {
      rootList.classList.add('d-none');
      childrenPanel.classList.add('d-none');
      searchResults.classList.remove('d-none');
      buildSearchResults(searchInput.value);
    } else {
      searchResults.classList.add('d-none');
      searchResults.innerHTML = '';
      if (mode === 'group') childrenPanel.classList.remove('d-none');
      else rootList.classList.remove('d-none');
    }
  });

  if (firstPageId) {
    const groupId = markActive(firstPageId);
    if (groupId) {
      showGroup(groupId);
      scrollActiveIntoView(firstPageId);
    } else {
      showRoot();
    }
  } else {
    showRoot();
  }
});
